import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";

function NtRootPageContainerScroll({ enabled, children }) {
  if (enabled) {
    return (
      <ScrollView
        style={styles.scroll}
        contentContainerStyle={{ flexGrow: 1, backgroundColor: "transparent" }}
      >
        {children}
      </ScrollView>
    );
  }

  return <View style={styles.container}>{children}</View>;
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: "transparent" },
  scroll: { flex: 1, backgroundColor: "transparent" },
});

export default NtRootPageContainerScroll;
